import {
  LAYOUT_OBJECT_DEFAULT_BACKGROUND,
  LAYOUT_OBJECT_DEFAULT_FONT_COLOR,
  LAYOUT_OBJECT_DEFAULT_FONT_FAMILY,
  LAYOUT_OBJECT_DEFAULT_FONT_SIZE,
} from '../../constants';
import { LayoutObject } from '../../types/types';

// Style a new object inherits from the last selected one (the template):
// colors and font — never caption/type/references, the new object is still an
// unassigned slot. Without a template the FE defaults apply. Materialized into
// the data so the canvas, the panel and the saved layout all agree.
export const getLayoutObjectInheritedStyle = (
  template: LayoutObject | null
): LayoutObject => ({
  backgroundColor:
    template?.backgroundColor ?? LAYOUT_OBJECT_DEFAULT_BACKGROUND,
  fontColor: template?.fontColor ?? LAYOUT_OBJECT_DEFAULT_FONT_COLOR,
  fontFamily: template?.fontFamily ?? LAYOUT_OBJECT_DEFAULT_FONT_FAMILY,
  fontSize: template?.fontSize ?? LAYOUT_OBJECT_DEFAULT_FONT_SIZE,
  ...(template?.fontStyle !== undefined && { fontStyle: template.fontStyle }),
});
